import styled from 'styled-components'

const Container = styled.div`
`
const ReviewContainer = styled.div`
    padding: 0 15px;
`
const Wrapper = styled.div`
    box-shadow: 0 0 12px 0 rgb(0 0 0 / 8%);
    background-color: #ffffff;
    min-height: 249px;
    position: relative;
    -webkit-flex: 1;
    -ms-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;

`
const SellerInfo = styled.div`
    border-radius: 9px;
  background-color: #f8f8f8;
  padding : 16px 22px;
  display: flex;
  margin-top: 15px;
  > div {
      flex:1;
      :last-child {
            max-width: 275px;
      }
      > h3 {
          font-size: 22px;
          font-family: 'latobold';
          margin: 4px 0;
          color: #007bff;
      }
      > h4 {
          font-size: 17px;
        margin: 4px 0;

      }
      > p {
            margin: 2px 0;
          
      }
      .favorite {
          svg {
              color: red;
          }
      }
  }
`
const ActionSection = styled.div`
    display: flex;
    gap: 30px;
    span {
        color: #2525ed;
        cursor: pointer;
    }
`
const CustomerReview = styled.div`
    
    > h2 {
        font-size:38px;
        margin:30px 0;
        span {
            color: #ff6008;
                    cursor: pointer;

        }
    }
   

`
const ShortingSection = styled.div`
            margin-bottom:30px;
`
const ReviewBox = styled.div`
    border-radius: 9px;
    background-color: #f8f8f8;
    padding : 16px 22px;
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
    > h3 {
        font-size: 17px;
    }
    > div {
        p {
            span {
            color: #ff6008;
        }
        }
    }
    >p {
        padding: 10px 0 0px 0;
        margin:0;
        font-size: 16px;
    }
`

export { Container, ReviewContainer, Wrapper, SellerInfo, ActionSection, CustomerReview, ShortingSection, ReviewBox }